import { PublicSpotifyArtist } from 'src/Redux/publicSpotifyArtistsApi'

export interface PreReleaseSignUpState {
  artist: PublicSpotifyArtist
  trackName: string
}

export const getPreReleaseSignUpState = (
  state: unknown,
): PreReleaseSignUpState | null => {
  const signUpState = state as Partial<PreReleaseSignUpState> | null

  if (!signUpState?.artist || !signUpState.trackName) {
    return null
  }

  return { artist: signUpState.artist, trackName: signUpState.trackName }
}
